import { render } from "./Cookies.vue?vue&type=template&id=04edff2f"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"
script.render = render

export default script